<template>
  <div>
    <px-view-header title="Cotações" :breadcrumbs="breadcrumbs"/>

    <px-cotacoes-marketplace-header @refresh="refresh" @change="onChangeFilter"/>
    <px-cotacoes-marketplace-list
      @update="refresh"
      :cotacoes="cotacoes"
      :loading="loading"
      @change="onChangeOptions"
      :options-list="optionsList"
    />
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import CotacoesMarketplaceHeader from '@/modules/marketplace/cotacoes/CotacoesMarketplaceHeader.vue';
import CotacoesMarketplaceList from '@/modules/marketplace/cotacoes/CotacoesMarketplaceList.vue';
import CotacaoMarketplaceService from '@/modules/marketplace/cotacoes/cotacao-marketplace-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Cotações' },
      ],
      searchText: null,
      cotacoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 25,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      optionsList: {},
    };
  },
  methods: {
    refresh() {
      this.getCotacoes();
    },
    onChangeFilter(filter) {
      this.listOptions.filter = filter;
      this.resetPage();
      this.getCotacoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCotacoes();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCotacoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CotacaoMarketplaceService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.cotacoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxCotacoesMarketplaceHeader: CotacoesMarketplaceHeader,
    pxCotacoesMarketplaceList: CotacoesMarketplaceList,
  },
};
</script>
